export const SHOW_REFERNCE_DETAILS = "الرقم المرجعي";
